import React, { PureComponent } from 'react';
import styles from './index.css';
import { wapactPageCount } from '../../../utils';
import { setlocal, getlocal } from '../../../base/base/storage';
import { callApp } from '@ifeng/callapp';
class BrowserGuideLayer extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            isShowLayer: false
        };
        this.pageLoadCount = 1;
        this.browserUI = {
            'baidu': {
                name: '百度',
                icon: 'https://x0.ifengimg.com/ucms/2021_02/2F9DE843EDD6C77A8895FF187F8DE91BBB6BBD37_size6_w147_h144.png'
            },
            'huawei': {
                name: '华为',
                icon: 'https://x0.ifengimg.com/ucms/2021_02/163A1CAD0DC456395E06DE3BFF584921942F62CE_size8_w144_h144.png'
            },
            'xiaomi': {
                name: '小米',
                icon: 'https://x0.ifengimg.com/ucms/2021_02/8C8329222CE7EC48FBC18C0BBDD83386E7A973EF_size5_w147_h144.png'
            },
            'oppo': {
                name: 'OPPO',
                icon: 'https://x0.ifengimg.com/ucms/2021_02/F21BB3B2186AA43FBDFF1B6E062D92207E2412C2_size14_w147_h144.png'
            },
            'uc': {
                name: 'UC',
                icon: 'https://x0.ifengimg.com/ucms/2021_02/E078A0F49181F47A1845EB4748D46BB7D20BEC67_size8_w147_h144.png'
            },
            'vivo': {
                name: 'VIVO',
                icon: 'https://x0.ifengimg.com/ucms/2021_02/B64A3557DCFCB39750DD097F245346F8F61A4B9E_size8_w144_h144.png'
            },
            'chrome': {
                name: 'Chrome',
                icon: 'https://x0.ifengimg.com/ucms/2021_02/49CDD772A1AEC630BD61A969B864BF2AB4C5FB99_size7_w147_h144.png'
            },
            'safari': {
                name: 'Safari',
                icon: 'https://x0.ifengimg.com/ucms/2021_02/9948710A292290B7491E46D9162195733DC071DF_size12_w147_h144.png'
            },
            '': {
                name: '',
                icon: ''
            }
        };
        this.defaultCongfig = {
            "huawei": "2",
            "xiaomi": "2",
            "oppo": "2",
            "chrome": "2",
            "safari": "2",
            "baidu": "2",
            "vivo": "2",
            "uc": "2",
            "continueBtnSet": 1,
            "endTime": '23:59:59',
            "leaveSet": 0,
            "openSet": 0,
            "startTime": '00:00:00',
            "addDay": 0,
        };
        this.initLayer = () => {
            const { browserConfig = this.defaultCongfig, storeInfo = '' } = this.props;
            const startTime = browserConfig.startTime;
            const endTime = browserConfig.endTime;
            const leaveSet = browserConfig.leaveSet;
            const openSet = browserConfig.openSet;
            const continueBtnSet = browserConfig.continueBtnSet;
            const browserName = this.getBrowserName();
            const theSameDay = getlocal(`theSameDay${storeInfo}`);
            const pageLoadCount = getlocal(`pageLoadCount${storeInfo}`);
            const liveDataTime = this.getDataTime().formatYND;
            const actionVal = getlocal(`action${storeInfo}`);
            const startTimeStamp = new Date(`${liveDataTime} ${startTime}`).getTime();
            const endTimeStamp = new Date(`${liveDataTime} ${endTime}`).getTime();
            const liveTimeStamp = new Date().getTime();
            if (theSameDay &&
                liveDataTime &&
                pageLoadCount &&
                ((actionVal === 'continue' &&
                    continueBtnSet &&
                    pageLoadCount > continueBtnSet) ||
                    (actionVal === 'open' &&
                        openSet &&
                        pageLoadCount > openSet) ||
                    (actionVal === 'leave' &&
                        leaveSet &&
                        pageLoadCount > leaveSet) ||
                    (liveTimeStamp <= startTimeStamp) ||
                    (liveTimeStamp >= endTimeStamp))) {
                return false;
            }
            if (browserName && browserConfig[browserName] === '1') {
                this.setState({
                    isShowLayer: true
                });
                document.body.style.position = 'fixed';
                document.body.style.top = '0';
            }
            return true;
        };
        this.getDataTime = () => {
            const myDate = new Date();
            const year = myDate.getFullYear();
            const month = myDate.getMonth() + 1;
            const day = myDate.getDate();
            const hours = myDate.getHours();
            const minutes = myDate.getMinutes();
            const seconds = myDate.getSeconds();
            return {
                formatYND: `${year}/${month}/${day}`
            };
        };
        this.getAddDataTime = (dataTime, addDay) => {
            const initDateTime = new Date(dataTime);
            const addDateTime = initDateTime.setDate(initDateTime.getDate() + addDay);
            return new Date(addDateTime);
        };
        this.initLoadCount = () => {
            const { storeInfo = '', browserConfig = this.defaultCongfig } = this.props;
            const theSameDay = getlocal(`theSameDay${storeInfo}`);
            const liveDataTime = this.getDataTime().formatYND;
            const liveTimeStamp = new Date(liveDataTime).getTime();
            const addDay = browserConfig.addDay || 0;
            // 当天是否首次进入
            if (!theSameDay ||
                liveTimeStamp > this.getAddDataTime(theSameDay, addDay).getTime() ||
                liveTimeStamp < new Date(theSameDay).getTime()) {
                setlocal(`theSameDay${storeInfo}`, liveDataTime);
                setlocal(`action${storeInfo}`, '');
                setlocal(`pageLoadCount${storeInfo}`, 1);
            }
            else {
                if (!getlocal(`action${storeInfo}`)) {
                    setlocal(`action${storeInfo}`, 'leave');
                }
                this.pageLoadCount = getlocal(`pageLoadCount${storeInfo}`) || 0;
                this.pageLoadCount++;
                setlocal(`pageLoadCount${storeInfo}`, this.pageLoadCount);
            }
        };
        this.getBrowserName = () => {
            const userAgent = (typeof navigator === 'object' && navigator.userAgent && navigator.userAgent.toLocaleLowerCase()) || '';
            if (!userAgent || !(userAgent.includes('android') || userAgent.includes('iphone'))) {
                return '';
            }
            if (userAgent.includes('baidu')) {
                return 'baidu';
            }
            if (userAgent.includes('huaweibrowser')) {
                return 'huawei';
            }
            if (userAgent.includes('miuibrowser')) {
                return 'xiaomi';
            }
            if (userAgent.includes('heytapbrowser')) {
                return 'oppo';
            }
            if (userAgent.includes('vivobrowser')) {
                return 'vivo';
            }
            if ((userAgent.includes('android') &&
                userAgent.length < 130 &&
                userAgent.includes('chrome')) ||
                (!userAgent.includes('android') &&
                    userAgent.includes('crios'))) {
                return 'chrome';
            }
            if ((userAgent.includes('ucbrowser') || userAgent.includes('linux; u;')) &&
                !userAgent.includes('miuibrowser') &&
                !userAgent.includes('vivobrowser') &&
                !userAgent.includes('oppo') &&
                !userAgent.includes('mqqbrowser') &&
                !userAgent.includes('heytapbrowser')) {
                return 'uc';
            }
            if (!userAgent.includes('android') &&
                userAgent.split('/').slice(-2)[0].split(' ').pop() === 'safari' &&
                !userAgent.includes('crios')) {
                return 'safari';
            }
            return '';
        };
        this.handleCallApp = () => {
            const { callAppConfig, clickCallAppConfig } = this.props;
            const { storeInfo = '' } = this.props;
            if (!getlocal(`action${storeInfo}`)) {
                setlocal(`action${storeInfo}`, 'open');
            }
            if (clickCallAppConfig) {
                clickCallAppConfig.ref = this.getBrowserName();
                wapactPageCount(clickCallAppConfig);
            }
            if (callAppConfig) {
                callApp(callAppConfig);
            }
        };
        this.closeLayer = () => {
            const { storeInfo = '' } = this.props;
            const { clickContinueConfig } = this.props;
            if (!getlocal(`action${storeInfo}`)) {
                setlocal(`action${storeInfo}`, 'continue');
            }
            this.setState({
                isShowLayer: false
            });
            if (clickContinueConfig) {
                // 关闭统计
                clickContinueConfig.ref = this.getBrowserName();
                wapactPageCount(clickContinueConfig);
            }
            document.body.style.position = '';
            document.body.style.top = '';
        };
    }
    componentDidMount() {
        this.initLoadCount();
        this.initLayer();
    }
    render() {
        const { isShowLayer } = this.state;
        const browserName = this.getBrowserName();
        const iconImage = browserName && this.browserUI[browserName].icon;
        const zhBrowserName = browserName && this.browserUI[browserName].name;
        return (isShowLayer && browserName && React.createElement("div", { className: styles.guideLayer },
            React.createElement("div", { className: styles.guideMenu },
                React.createElement("h2", { className: styles.guideMenuTip }, "\u7EE7\u7EED\u6D4F\u89C8\u7CBE\u5F69\u5185\u5BB9"),
                React.createElement("div", { className: styles.guideMenuItem },
                    React.createElement("img", { className: styles.guideMenuIcon, src: "https://x0.ifengimg.com/ucms/2020_47/72D5F2C83657D87D6027573A0E523497387BBC5E_w144_h144.png" }),
                    React.createElement("div", { className: styles.guideMenuInfo },
                        React.createElement("h2", { className: styles.guideMenuName }, "\u51E4\u51F0\u65B0\u95FB"),
                        React.createElement("p", { className: styles.guideMenuBref }, "\u5168\u7403\u70ED\u70B9\u4E00\u7F51\u6253\u5C3D")),
                    React.createElement("img", { className: styles.guideMenuButton, onClick: this.handleCallApp, src: "https://x0.ifengimg.com/ucms/2020_47/25F9C4EBDD935FBE7F2D606CEF7D6310DA5F9FCC_w228_h96.png" })),
                React.createElement("div", { className: styles.guideMenuItem },
                    React.createElement("img", { className: styles.guideMenuIcon, src: iconImage }),
                    React.createElement("div", { className: styles.guideMenuInfo },
                        React.createElement("h2", { className: styles.guideMenuName }, zhBrowserName)),
                    React.createElement("img", { className: styles.guideMenuButton, onClick: this.closeLayer, src: "https://x0.ifengimg.com/ucms/2020_47/1A9CA5465B6A964119B212FF0C02D37460038204_w228_h96.png" })))));
    }
}
export default BrowserGuideLayer;
